import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import mapBackground from '../../Images/farm.jpeg';

const TamilNaduSchemesDashboard = () => {

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '92vh',
          // width: "100%",
          backgroundImage: `url(${mapBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: { xs: 'scroll', md: 'fixed' }, // Disable parallax on mobile for better perf
          p: { xs: 2, sm: 3, md: 0 }, // Horizontal padding on mobile, none on desktop
        }}
      >
        <Paper
          elevation={12}
          sx={{
            textAlign: 'center',
            p: { xs: 3.5, sm: 4, md: 6 }, // Smaller padding on mobile
            maxWidth: 650,
            width: '80%', // Take available width within padding
            borderRadius: { xs: 3, sm: 4 }, // Slightly smaller radius on mobile
            border: '1px solid rgba(255,255,255,0.15)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            position: 'relative',
            overflow: 'hidden',
            zIndex: 1,
            backdropFilter: 'blur(17px)',
            background: "transparent"
          }}
        >
          {/* Decorative Top Border */}
          <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 5, bgcolor: '#ffc022' }} />

          {/* Logo */}
          <Box
            sx={{
              width: { xs: 72, sm: 85, md: 100 }, // Smaller logo on mobile
              height: { xs: 72, sm: 85, md: 100 },
              bgcolor: 'transparent',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              mb: { xs: 2, sm: 2.5, md: 4 }, // Less bottom margin on mobile
            }}
          >
            <img
              src="/TN.png"
              alt="Tamil Nadu Logo"
              style={{
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>

          {/* Title */}
          <Typography
            variant="h5"
            fontWeight={800}
            color="#ffffff"
            gutterBottom
            sx={{
              letterSpacing: '-0.5px',
              fontSize: { xs: '1.25rem', sm: '1.4rem', md: '1.5rem' }, // Scale down on mobile
              lineHeight: 1.3,
            }}
          >
            Tamil Nadu Government Schemes
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: { xs: 3, md: 4 },
              fontSize: { xs: '0.875rem', sm: '0.95rem', md: '1.1rem' }, // Smaller text on mobile
              lineHeight: { xs: 1.6, md: 1.7 },
              px: { xs: 0.5, sm: 0 }, // Tiny horizontal padding to prevent edge clipping
            }}
          >
            Explore various <Box component="span" sx={{ color: '#f8d06b', fontWeight: 700 }}>welfare and development schemes</Box> launched by the Government of Tamil Nadu.
            <br />
            Find information on initiatives across sectors like agriculture, education, health, and social welfare to benefit citizens.
          </Typography>

          {/* CTA Button */}
          {/* <Button
            variant="contained"
            endIcon={<ArrowForwardIcon sx={{ fontSize: { xs: 16, md: 18 } }} />}
            sx={{
              bgcolor: '#ffc022',
              color: '#1a1a1a',
              textTransform: 'none',
              fontWeight: 700,
              fontSize: { xs: '0.875rem', sm: '0.95rem', md: '1rem' },
              borderRadius: 2.5,
              py: { xs: 1, md: 1.2 },
              px: { xs: 3, sm: 4 },
              boxShadow: '0 4px 14px rgba(255, 192, 34, 0.35)',
              width: { xs: '100%', sm: 'auto' }, // Full-width on mobile
              '&:hover': {
                bgcolor: '#ffca42',
                boxShadow: '0 6px 20px rgba(255, 192, 34, 0.5)',
                transform: 'translateY(-1px)',
              },
              '&:active': {
                transform: 'scale(0.98)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            Explore Schemes
          </Button> */}

        </Paper>
      </Box>
    </>
  );
};

export default TamilNaduSchemesDashboard;